/** @format */

import { CompareProductDetails, Environment } from '@shared/data-access/interfaces';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, retry, throwError } from 'rxjs';

import { HttpService } from '@shared/data-access/services';
import { MediaType } from '@shared/data-access/enums';

@Injectable({
  providedIn: 'root',
})
export class CompareDao {
  private readonly httpService = inject(HttpService);
  private readonly environment = inject(Environment);
  private readonly http = inject(HttpClient);

  getProductDetails(
    ecodes: string[],
    isClearance = false,
    retries = 1,
  ): Observable<CompareProductDetails> {
    let httpRequestParams = new HttpParams();

    httpRequestParams = httpRequestParams
      .set('partnumbers', ecodes.join(','))
      .set('clearance', isClearance);

    let httpHeaders = new HttpHeaders({
      Accept: MediaType.APPLICATION_JSON,
    });

    // Get Origin Host Header
    const origin = this.httpService.getRequestHeaderValueAndSetStateKey('ORIGIN_HOST');
    if (origin) {
      httpHeaders = httpHeaders.set('Origin', origin);
    }

    const httpOptions = {
      httpHeaders,
      params: httpRequestParams,
      withCredentials: false,
    };

    return this.http
      .get<CompareProductDetails>(`${this.environment.api.compare}`, httpOptions)
      .pipe(
        catchError((error) => throwError(() => error)),
        retry(retries),
      );
  }
}
